<div width="30" height="30" class="shopping-cart-button-container" *ngIf="!showBlueButton && !hoffmanProduct">
    <button mat-icon-button (click)="onClick()" [disabled]="disable" matTooltip="Agregar al carrito">
        <img src="assets/icons/shopping-cart.svg" alt="favorite">
    </button>
</div>
<div width="30" height="30" class="shopping-cart-button-container" *ngIf="!showBlueButton && hoffmanProduct">
    <button mat-icon-button (click)="addHoffmanProduct()" [disabled]="disable" matTooltip="Agregar al carrito">
        <img src="assets/icons/shopping-cart.svg" alt="favorite">
    </button>
</div>
<div *ngIf="showBlueButton">
    <button mat-raised-button color="primary" class="font-size-button button-blue" (click)="onClick()">
        Agregar al carrito</button>
</div>